import React from "react";
import { IoIosSearch, IoMdMenu } from "react-icons/io";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";

const Tnb = ({ handleLogoutModal, url, homepageInfo, setClickSideMenu, theme, isMatch }) => {
  const navigate = useNavigate();
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });

  const user = useSelector((state) => state?.user?.data[0]);

  const getHelpdesk = () => {
    const url = "https://pcanypro.freshdesk.com/helpdesk/attachments/150024300725";
    const a = document.createElement("a");
    a.href = url;
    const fileName = url.split("/").pop() || "helpdesk";
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const menuItems = [
    homepageInfo?.cmpnyNo === 15922 && theme === 4
      ? {
          key: "support",
          label: "원격지원",
          className: "support",
          clickEvent: getHelpdesk,
        }
      : null,
    user
      ? [
          {
            key: "cart",
            label: "장바구니",
            clickEvent: () => navigate(`/shop/mypage/cart`),
          },
          {
            key: "mypage",
            imgKey: "login",
            label: "마이페이지",
            clickEvent: () => navigate(`/shop/mypage`),
          },
          {
            key: "logout",
            label: "로그아웃",
            clickEvent: handleLogoutModal,
          },
        ]
      : [
          {
            key: "login",
            label: "로그인",
            clickEvent: () => navigate(`/shop${url ? `/${url}` : ""}/login`),
          },
        ],
    !isMatch && {
      key: "search",
      icon: <IoIosSearch />,
      className: "tnb_btn",
      clickEvent: () => navigate(homepageInfo ? `${url}/search?keyword=` : "search?keyword="),
    },
    isTablet && {
      key: "menu",
      icon: <IoMdMenu />,
      className: "tnb_btn",
      clickEvent: () => setClickSideMenu(true),
    },
  ]
    .flat()
    .filter(Boolean);

  return (
    <ul className="tnb">
      {menuItems.map(({ key, imgKey = null, label, icon, className, clickEvent }) => (
        <li key={key} className={className} onClick={clickEvent}>
          {icon ? <i className="icon">{icon}</i> : <span>{label}</span>}
        </li>
      ))}
    </ul>
  );
};

export default Tnb;
